import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import React, { Fragment, useState } from "react";
import "./AddressCards.css";

function AddressCards({address}) {

  const [openDltConfModal, setOpenDltConfModal] = useState(false);  


if (setOpenDltConfModal) {
  document.body.classList.add('active_modal')
} else {
  document.body.classList.remove('active_modal')
}

const [open, setOpen] = React.useState(false);

const handleClickOpen = () => {
  setOpen(true);
};

const handleClose = () => {
  setOpen(false);
};

console.log({address})

  return (
    <Fragment>
      <div className="w-full border-1 border-pink-600 p-3 rounded-lg text-xs relative">
        <div className="w-full">
          <input
          type='radio'
          className='absolute right-2 top-2'
          />
          {/* <div className="addrs_card_inr_box">
            <div className="addrs_type"><span className="pro_desc">{addres.addressType}</span></div>
            <div className="adrs_n_and_ph">
              <div>{addres.name}</div>
              
            </div>
            <div className="full_addrs">
              <span className="pro_desc">{addres.addressFull},</span>
              <span className="pro_desc">{addres.locality},</span>
              <span className="pro_desc">{addres.cityDistrict},</span>
              <span className="pro_desc">{addres.landmark}</span>
            </div>
            <div className="s_and_pin">
              <span className="pro_desc">{addres.state}</span>
              <span className="pro_desc">-{addres.pinCode}</span>
            </div>
            <div>
              <span className="pro_desc">Mobile: {addres.mobileNumber}</span>
            </div>
          </div> */}
          {/* {addres.isDefault ? <span className="adrs_default">Default</span> : null} */}
          <div className="w-full">
            <div>{address.name}</div>
            <div>{address.addressFull}</div>
            <div>{address.cityDistrict}, <span>{address.pinCode}</span></div>
            <div>{address.landmark}</div>
          </div>
          <div className="absolute right-1 bottom-1 flex gap-1 text-xs">
            <button className='px-3 py-1 rounded bg-blue-50'>EDIT</button>
            <button className='px-3 py-1 rounded bg-red-50' onClick={handleClickOpen}>REMOVE</button>
          </div>
        </div>
      </div>
      <div>
            <Dialog
              open={open}
              onClose={handleClose}
              PaperProps={{
                sx: {
                  width: "24%",
                  height: 180
                }
              }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <div onClick={handleClose} className='close_mdl_btn'><CloseRoundedIcon fontSize="small" /></div>
              <DialogTitle id="alert-dialog-title" style={{ fontSize: "1.1rem", fontWeight: "600", fontFamily: "Philosopher", height: '50px', display: 'flex', alignItems: 'center'}}>
                {"Remove address"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description" style={{ fontSize: "1rem", fontFamily: "Philosopher", color: "black" }}>
                  Are you sure you want to remove your address?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} style={{ width: "50%", color: "black", fontFamily: "Philosopher", fontWeight: "600" }}>CLOSE</Button>
                <Button  autoFocus style={{ width: "50%", color: "crimson", fontFamily: "Philosopher", fontWeight: "600" }}>
                  REMOVE
                </Button>
              </DialogActions>
            </Dialog>
          </div>
    </Fragment>
  );
}

export default AddressCards;
